import React, { FC, Fragment, MouseEvent, useEffect, useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Button, Divider, Popover, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Buttons, CreatedBy, Group, Options, PostType, Shared } from './Filter';
import { SearchPostsFilter } from 'api';
import { PaddedPaper } from 'components';
import theme from 'theme';
import { useSearchESContext } from '../SearchESContext';

const SearchFilters: FC = () => {
  const { t } = useTranslation();
  const { state } = useSearchESContext();

  const [anchorEl, setAnchorEl] = useState(null);
  const [tempFilters, setTempFilters] = useState<SearchPostsFilter>({ ...state.post_filter });

  useEffect(() => {
    setTempFilters(state.post_filter);
  }, [state.post_filter]);

  function handleReconciliation() {
    setTempFilters(state.post_filter);
  }

  function onClickButton(event: MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function onClose() {
    setAnchorEl(null);
  }

  return (
    <Fragment>
      <Box height="100%" display="flex">
        <Button
          variant="contained"
          size="large"
          onClick={onClickButton}
          endIcon={anchorEl === null ? <ExpandMore /> : <ExpandLess />}
          sx={{
            background: theme.palette.background.default,

            '&:hover': {
              border: '1px solid transparent',
              background: theme.palette.background.default,
            },
          }}
        >
          {t('analytics:filters')}
        </Button>
      </Box>

      <Popover
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={onClose}
        TransitionProps={{
          onExited: handleReconciliation,
          onEnter: handleReconciliation,
        }}
      >
        <PaddedPaper sx={{ width: 700 }}>
          <Grid container spacing={2}>
            <Grid>
              <Typography variant="h6">{t('admin:filters')}</Typography>
            </Grid>

            <Grid xs={12}>
              <Divider />
            </Grid>

            <Grid xs={12} container spacing={2}>
              <Grid xs={12}>
                <Group filters={tempFilters} setFilters={setTempFilters} />
              </Grid>

              <Grid xs={12}>
                <CreatedBy filters={tempFilters} setFilters={setTempFilters} />
              </Grid>

              <Grid xs={12}>
                <PostType filters={tempFilters} setFilters={setTempFilters} />
              </Grid>

              <Grid xs={12}>
                <Shared filters={tempFilters} setFilters={setTempFilters} />
              </Grid>
            </Grid>

            <Grid xs={12}>
              <Divider />
            </Grid>

            <Grid xs={12}>
              <Options filters={tempFilters} setFilters={setTempFilters} />
            </Grid>

            <Grid xs={12}>
              <Divider />
            </Grid>

            <Buttons tempFilters={tempFilters} setTempFilters={setTempFilters} onClose={onClose} />
          </Grid>
        </PaddedPaper>
      </Popover>
    </Fragment>
  );
};

export default SearchFilters;
